import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M19.063 24.063h-8.125a2.5 2.5 0 0 1-2.5-2.5V8.438a2.5 2.5 0 0 1 2.5-2.5h8.125a2.5 2.5 0 0 1 2.5 2.5v13.124a2.5 2.5 0 0 1-2.5 2.5Zm-4.375-3.125h.624" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);